module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "popup-attention"
  }, [_c('div', {
    staticClass: "popup-attention__content"
  }, [_c('h2', {
    staticClass: "popup-attention__title-big"
  }, [_vm._v("\n            Внимание!\n        ")]), _vm._v(" "), _c('h3', {
    staticClass: "popup-attention__title popup__title"
  }, [_vm._v("\n            Конкурс завершен, но вы все еще можете пройти этот увлекательный тест на знание истории компьютерной игры серии FIFA.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-432bc94c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popups/Attention.vue
// module id = 499
// module chunks = 1